var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isEmpty } from 'lodash';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import OutsideClickHandler from 'react-outside-click-handler';
import Button from '../button';
import DaterangePicker from '../daterange-picker';
import Icon from '../icon';
import Popover from '../popover';
import { Styled } from './style';
var MultilineDateRangePicker = /** @class */ (function (_super) {
    __extends(MultilineDateRangePicker, _super);
    function MultilineDateRangePicker(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.addInput = function () {
            var lastValue = _this.state.values[_this.state.values.length - 1];
            if (_this.state.values.length === 0 || lastValue.start !== '') {
                _this.setState(function (prevState) { return ({
                    values: __spreadArrays(prevState.values, [{ start: '', end: '' }]),
                    focusIndex: prevState.focusIndex + 1,
                }); });
            }
        };
        _this.removeInput = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var updatedValues;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updatedValues = this.state.values.filter(function (input, index) { return index !== id; });
                        return [4 /*yield*/, this.setState(function (prevState) { return ({
                                values: updatedValues,
                                focusIndex: prevState.focusIndex - 1,
                            }); })];
                    case 1:
                        _a.sent();
                        this.handleChange(updatedValues);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.dateRangePickerOnChange = function (index, data) {
            var values = __spreadArrays(_this.state.values);
            values[index] = data;
            _this.setState({
                isOpen: false,
                values: values,
            }, function () {
                _this.handleChange(_this.state.values);
            });
        };
        _this.handleChange = function (values) {
            _this.setState({
                isOpen: false,
            });
            if (_this.props.onChange) {
                _this.props.onChange(values, _this.state.conflictList);
            }
        };
        _this.handleOutsideClick = function () {
            if (_this.state.values.length > 0 && _this.state.values[0].start === '') {
                _this.setState({
                    isOpen: false,
                    values: [],
                });
            }
        };
        var dateValues = __spreadArrays(_this.props.values);
        _this.state = {
            values: dateValues,
            focusIndex: 0,
            conflictList: [],
            isOpen: (_a = props.isOpen) !== null && _a !== void 0 ? _a : false,
        };
        return _this;
    }
    MultilineDateRangePicker.getDerivedStateFromProps = function (props, state) {
        if (props.values === state.values) {
            return { values: props.values };
        }
        return null;
    };
    MultilineDateRangePicker.prototype.componentDidUpdate = function (props, state) {
        if ((isEmpty(this.props.values) && this.props.isOpen && (props.isOpen !== this.props.isOpen))) {
            this.setState({
                isOpen: true,
                values: [{ start: '', end: '' }],
            });
        }
    };
    MultilineDateRangePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, compact = _a.compact, disabled = _a.disabled, locale = _a.locale, disablePastDateSelection = _a.disablePastDateSelection, overlapIndexes = _a.overlapIndexes;
        var values = this.state.values;
        return (React.createElement(OutsideClickHandler, { onOutsideClick: this.handleOutsideClick },
            React.createElement(Styled, null,
                values.length >= 1 && values.map(function (value, index) {
                    var isOverlap = overlapIndexes !== undefined ? overlapIndexes === null || overlapIndexes === void 0 ? void 0 : overlapIndexes.some(function (item) { return item === index; }) : false;
                    return (React.createElement("div", { key: index, className: "item-row" },
                        React.createElement("div", { className: "date-range-input" },
                            React.createElement(DaterangePicker, { compact: compact, locale: locale, value: value, disabled: disabled, isOpen: (_this.state.isOpen && value.start === '') || value.start === '', onChange: function (v) { return _this.dateRangePickerOnChange(index, v); }, disablePastDateSelection: disablePastDateSelection })),
                        React.createElement(Button, { onClick: function () {
                                _this.removeInput(index);
                            }, transparent: true },
                            React.createElement(Icon, { name: "remove-fill" })),
                        isOverlap &&
                            React.createElement(Popover, { trigger: React.createElement(Icon, { name: "warning", className: "icon-warning" }), content: "Conflicts with another date", position: "top center", inverted: true })));
                }),
                this.props.disabled ? (React.createElement(React.Fragment, null,
                    (this.state.values.length >= 1 && this.state.values[0].start !== '') &&
                        React.createElement("p", { className: "warning" },
                            React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.add_date.warning_message", defaultMessage: "This date is redundant when it's set to play every day" })),
                    React.createElement(Popover, { trigger: React.createElement(Button, { mini: true, disabled: true, className: "btn-add disabled" },
                            React.createElement(Icon, { name: "plus-fill" }),
                            this.state.values.length >= 1 ? (React.createElement(FormattedMessage, { id: "ui_component.multiline_time_input.add", defaultMessage: "Add" })) : (React.createElement(FormattedMessage, { id: "ui_component.multiline_date_input.add_specific_date", defaultMessage: "Specific date" }))), on: "hover", content: React.createElement(FormattedMessage, { id: "ui_component.schedule_popover.add_date.help_message", defaultMessage: "Unable to add specific date when it's set to play every day" }), position: "bottom center", inverted: true }))) : (React.createElement(Button, { mini: true, onClick: this.addInput, disabled: this.props.disabled },
                    React.createElement(Icon, { name: "plus-fill" }),
                    this.state.values.length >= 1 ? (React.createElement(FormattedMessage, { id: "ui_component.multiline_time_input.add", defaultMessage: "Add" })) : (React.createElement(FormattedMessage, { id: "ui_component.multiline_date_input.add_specific_date", defaultMessage: "Specific date" })))))));
    };
    return MultilineDateRangePicker;
}(React.Component));
export { MultilineDateRangePicker };
export default MultilineDateRangePicker;
//# sourceMappingURL=index.js.map